/* ============================================================
   ⭐ R540 · Nachtschicht 22./23.09.2026 — kleine, echte Helfer für alle Seiten.
   Eigene Datei, damit die Änderungen der Nacht nicht in fremden Dateien
   verstreut liegen (vier Sessions arbeiten parallel am Theme).

   1. Erreichbar-Anzeige: Die Statuszeile über dem Fuß zeigt, ob gerade
      jemand erreichbar ist — statt der alten Fake-LED „System online".
   ============================================================ */
(function () {
  'use strict';

  /* ---------- 1. Erreichbar-Anzeige --------------------------------
     Bürozeit Mo–Fr 9–18 Uhr, Europe/Berlin, bayerische Feiertage.
     Rechnet im Browser, braucht keinen Server, kann nicht „hängen". */
  function osterSonntag(j) { // Gauß/Anonymer gregorianischer Algorithmus
    var a = j % 19, b = Math.floor(j / 100), c = j % 100, d = Math.floor(b / 4), e = b % 4,
        f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30,
        i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451),
        mon = Math.floor((h + l - 7 * m + 114) / 31), tag = ((h + l - 7 * m + 114) % 31) + 1;
    return Date.UTC(j, mon - 1, tag);
  }
  function feiertag(j, mo, t) { // Bayern (katholisch geprägte Gemeinde), mo 1-basiert
    var fest = { '1.1': 'Neujahr', '6.1': 'Heilige Drei Könige', '1.5': 'Tag der Arbeit', '15.8': 'Mariä Himmelfahrt',
      '3.10': 'Tag der Deutschen Einheit', '1.11': 'Allerheiligen', '25.12': '1. Weihnachtstag', '26.12': '2. Weihnachtstag' };
    if (fest[t + '.' + mo]) return fest[t + '.' + mo];
    var o = osterSonntag(j), heute = Date.UTC(j, mo - 1, t), tagMs = 864e5;
    var beweglich = { '-2': 'Karfreitag', '1': 'Ostermontag', '39': 'Christi Himmelfahrt', '50': 'Pfingstmontag', '60': 'Fronleichnam' };
    return beweglich[String(Math.round((heute - o) / tagMs))] || null;
  }
  function berlinJetzt() {
    try {
      var teile = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Berlin', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' })
        .formatToParts(new Date()).reduce(function (o, p) { o[p.type] = p.value; return o; }, {});
      var j = +teile.year, mo = +teile.month, t = +teile.day;
      var wt = new Date(Date.UTC(j, mo - 1, t)).getUTCDay() || 7; // 1=Mo … 7=So
      return { j: j, mo: mo, t: t, wt: wt, std: +teile.hour + (+teile.minute) / 60 };
    } catch (_) { return null; }
  }
  var WT_NAME = ['', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag', 'Sonntag'];

  function erreichbar(el) {
    var txt = el.querySelector('[data-usp-erreichbar-text]');
    var jetzt = berlinJetzt();
    if (!txt || !jetzt) return;
    var tage = (el.dataset.tage || '1,2,3,4,5').split(',').map(Number);
    var von = +el.dataset.von || 9, bis = +el.dataset.bis || 18;
    var ft = feiertag(jetzt.j, jetzt.mo, jetzt.t);
    var arbeitstag = function (j, mo, t, wt) { return tage.indexOf(wt) >= 0 && !feiertag(j, mo, t); };
    var offen = arbeitstag(jetzt.j, jetzt.mo, jetzt.t, jetzt.wt) && jetzt.std >= von && jetzt.std < bis;

    var satz;
    if (offen) {
      satz = 'Jetzt erreichbar · heute bis ' + bis + ' Uhr';
    } else if (arbeitstag(jetzt.j, jetzt.mo, jetzt.t, jetzt.wt) && jetzt.std < von) {
      satz = 'Heute ab ' + von + ' Uhr erreichbar';
    } else {
      // nächsten Arbeitstag suchen (max. 10 Tage)
      var d = new Date(Date.UTC(jetzt.j, jetzt.mo - 1, jetzt.t)), wann = '';
      for (var n = 1; n <= 10; n++) {
        d.setUTCDate(d.getUTCDate() + 1);
        var wt = d.getUTCDay() || 7;
        if (arbeitstag(d.getUTCFullYear(), d.getUTCMonth() + 1, d.getUTCDate(), wt)) { wann = n === 1 ? 'morgen' : WT_NAME[wt]; break; }
      }
      satz = (ft ? 'Heute ' + ft + ' · ' : '') + 'Wieder erreichbar ' + wann + ' ab ' + von + ' Uhr';
    }
    txt.textContent = satz;
    el.classList.toggle('is-offen', offen);
    el.classList.toggle('is-zu', !offen);
  }
  /* R542: Die Handy-Schublade trägt jetzt auch eine Erreichbarkeitszeile. Der Kopf wird nach dem
     Laden neu aufgebaut (Hydration) — die Elemente vom DOMContentLoaded gibt es dann nicht mehr,
     die Zeile blieb auf dem Platzhalter stehen. Deshalb bei jedem Durchgang NEU suchen, dazu nach
     `load` und beim Öffnen des Menüs. */
  function alleErreichbar() { Array.prototype.forEach.call(document.querySelectorAll('[data-usp-erreichbar]'), erreichbar); }
  function initErreichbar() {
    if (!document.querySelector('[data-usp-erreichbar]')) return;
    alleErreichbar();
    window.addEventListener('load', alleErreichbar, { once: true });
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('[data-usp-menu-open], .header__icon--menu')) window.setTimeout(alleErreichbar, 60);
    });
    // jede Minute nachziehen (wer um 17:59 auf der Seite steht, sieht 18:00 richtig)
    window.setInterval(alleErreichbar, 60000);
  }
  window.uspErreichbar = { feiertag: feiertag, berlinJetzt: berlinJetzt };

  /* ---------- 2. Bedienhilfe-Knopf auf Deutsch ------------------------
     Die App „Access Pro" setzt aria-label UND title auf „Open Accessibility
     Menu" (jede Seite, auch als Maus-Hinweis sichtbar). Das Menü selbst ist
     deutsch — nur der Knopf nicht. Die App lädt nachträglich, also kurz warten. */
  function initBedienhilfe() {
    var n = 0;
    var t = window.setInterval(function () {
      var k = document.getElementById('asw-icon') || document.querySelector('#Access-Pro-Icon button, .asw-widget button');
      if (k) {
        k.setAttribute('aria-label', 'Bedienhilfen öffnen');
        k.setAttribute('title', 'Bedienhilfen öffnen');
        window.clearInterval(t);
      } else if (++n > 40) window.clearInterval(t);
    }, 500);
  }

  /* ---------- 3. Karte erst nach Klick (Kontaktseite) ----------------
     Das Google-Maps-iframe lud vorher sofort — auch nach „Ablehnen" im
     Cookie-Banner. Jetzt liegt es in einem <template> und kommt erst auf Wunsch. */
  function initKarte() {
    document.addEventListener('click', function (e) {
      var k = e.target.closest && e.target.closest('[data-usp-karte-laden]');
      if (!k) return;
      var box = k.closest('[data-usp-karte]');
      var tpl = box && box.querySelector('template[data-usp-karte-inhalt]');
      if (!tpl) return;
      box.innerHTML = tpl.innerHTML;
      box.classList.add('is-geladen');
    });
  }

  function init() { initErreichbar(); initBedienhilfe(); initKarte(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
